<template>
  <div class="module">
    <v-container fluid>
      <v-row>
        <v-col 
          v-for="(mod, index) in modules"
          cols="6"
          sm="6"
          md="2"
          :key="index"
        >
          <v-hover v-slot="{ hover }">
            <v-card 
              :to="mod.to"
              :color="$vuetify.breakpoint.lgAndUp ? 'rgb(0, 0, 0, 0.5)' : 'primary lighten-1'" 
              class="text-center pt-4 rounded-bl-xl rounded-tr-xl"
              :elevation="hover ? 16 : 2"
              height="100%"
            >
              <v-responsive>
                <v-avatar size="70">
                  <img :src="require(`@/assets/home/icon_v2/${mod.src}`)" :alt="mod.src">
                </v-avatar>
              </v-responsive>
              <v-card-text>
                <div class="subheading" :class="$style.modTitle">
                  {{mod.title}}
                </div>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'Module',
  data () {
    return {
      modules: [
        {
          src: "Connect.png",
          title: 'Doanh nghiệp sản xuất',
          to: '/business'
        },
        {
          src: "Product.png",
          title: 'Sản phẩm nông nghiệp',
          to: '/products'
        },
        {
          src: "Environment.png",
          title: 'Quan trắc môi trường',
          to: '/environment'
        },
        {
          src: "Map.png",
          title: 'Bản đồ nông nghiệp',
          to: '/agri-map'
        },
        {
          src: "Fap.png",
          title: 'Hỏi & đáp kỹ thuật',
          to: '/supports'
        },
        {
          src: "MarketPrice.png",
          title: 'Thị trường nông sản',
          to: '/market-price'
        }
      ]
    }
  }
}
</script>
<style module>
  .modTitle {
    color: #fff;
    font-size: 12px;
    text-transform: uppercase;
  }
</style>